import proxy from './axios';

export const fetchConversations = async () => {
  const { data } = await proxy.get('/chat/conversations');
  return data?.conversations || [];
};

export const searchChatUsers = async (query) => {
  const { data } = await proxy.get('/chat/conversations/users/search', { params: { q: query } });
  return data?.users || [];
};

export const startConversation = async (userId) => {
  const { data } = await proxy.post('/chat/conversations', { userId });
  return data?.conversation;
};

export const fetchMessages = async (conversationId, { before, limit } = {}) => {
  const { data } = await proxy.get(`/chat/conversations/${conversationId}/messages`, {
    params: { before, limit },
  });
  return data?.messages || [];
};

export const sendMessage = async (conversationId, text) => {
  const { data } = await proxy.post(`/chat/conversations/${conversationId}/messages`, { text });
  return data?.message;
};

export const markConversationRead = async (conversationId) => {
  await proxy.patch(`/chat/conversations/${conversationId}/read`);
};

export const editMessage = async (messageId, text) => {
  const { data } = await proxy.patch(`/chat/messages/${messageId}`, { text });
  return data?.message;
};

export const deleteMessage = async (messageId) => {
  const { data } = await proxy.delete(`/chat/messages/${messageId}`);
  return data?.message;
};
